import { apiService } from './api'
import type { Nutrition, CreateNutritionData, UpdateNutritionData, PaginationParams, PaginatedResponse } from '@/types'

class NutritionService {
  async getNutrition(params?: PaginationParams): Promise<PaginatedResponse<Nutrition>> {
    const response = await apiService.api.get('/admin/nutrition', { params })
    return response.data.data
  }

  async getAllNutrition(): Promise<{ data: Nutrition[] }> {
    const response = await apiService.api.get('/admin/nutrition/all')
    return response.data
  }

  async getNutritionItem(id: string | number): Promise<Nutrition> {
    const response = await apiService.api.get(`/admin/nutrition/${id}`)
    return response.data.data
  }

  async createNutrition(data: CreateNutritionData) {
    const response = await apiService.api.post('/admin/nutrition', data)
    return response.data
  }

  async updateNutrition(id: string | number, data: UpdateNutritionData) {
    const response = await apiService.api.put(`/admin/nutrition/${id}`, data)
    return response.data
  }

  async deleteNutrition(id: string | number): Promise<void> {
    await apiService.api.delete(`/admin/nutrition/${id}`)
  }

  async getNutritionStats(): Promise<{
    total: number
  }> {
    const response = await apiService.api.get('/admin/nutrition/stats')
    return response.data.data
  }
}

export const nutritionService = new NutritionService()